<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-19 11:06:52
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ModelVersion.vue
-->
<template>
    <div class="mt-5">
        <label class="block text-white text-sm mb-[10px]">
            {{ t('tools.model_version') }}
        </label>
        <div class="grid grid-cols-2 gap-1 sm:gap-2 ">
            <div
                v-for="item in props.model_version_list"
                :key="item.model_key"
                @click="testFun(item)"
                :class="[
                    'flex bg-tool-default-black border border-white/[.06] min-h-[80px] cursor-pointer hover:border-white/30  items-center justify-center gap-[10px] rounded-[10px] transition-all duration-300  p-[10px]',
                ]"
            >
                <div class="flex flex-col gap-[10px] items-start">
                    <div class="flex justify-start items-center gap-[10px]">
                        <img
                            :src="item.thumbnail"
                            alt="thumbnail"
                            class="w-[30px] h-[30px] object-cover"
                            loading="lazy"
                        />
                        <span class="text-white text-sm">{{ item.title }}</span>
                    </div>
                    <span class="text-sub-title text-[10px] line-clamp-2">
                        {{ item.desc }}
                    </span>
                </div>
                <img
                    :src="
                        model_version === item.model_key
                            ? checkedIcon
                            : notCheckedIcon
                    "
                    alt="checked"
                    class="w-5 h-5 object-cover"
                />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, watch } from 'vue'
import { useI18n } from '../../composables/useI18n'

const checkedIcon =
    'https://static.weryai.com/growth/image/4ebae3f3edb8f4f52281d018c7816648.webp'
const notCheckedIcon =
    'https://static.weryai.com/growth/image/bd6f71cdf35a64773b80d7a5a9930322.webp'
interface ModelVersionItem {
    thumbnail: string
    title: string
    desc: string
    model_key: string
}

const props = withDefaults(
    defineProps<{
        model_version_list: ModelVersionItem[]
    }>(),
    {
        model_version_list: () => [],
    }
)

const { t, locale } = useI18n()
const testFun = (item: ModelVersionItem) => {
    model_version.value = item.model_key
}

const model_version = defineModel<string>('model_version')
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
